import {modals, permissionGroups} from "../../../ducks";
import {connect} from "react-redux";
import React, {useState} from "react";
import {Formik} from "formik";
import ModalComponent from "../../ModalComponent";
import {Button, Form, FormControl, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import ValidationErrors from "../../forms/ValidationErrors";
import PropTypes from "prop-types";
import './styles/PermissionGroups.scss';
import {PermissionChecklist} from "./PermissionChecklist";


const EditGroupModal = ({flags, onClose, onSave, onUnexpectedError, permissionGroup = {}}) => {
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const initialValues = {id: permissionGroup.id, name: permissionGroup.name || ''}
  flags.forEach(flag => initialValues[flag.canonical_name] = permissionGroup[flag.canonical_name])

  return <Formik
    initialValues={initialValues}
    onSubmit={
      values => {
        setLoading(true);
        onSave(values)
          .then(onClose)
          .catch(response => {
            setLoading(false);
            if (response.permission_group && response.permission_group.errors) {
              setErrors(response.permission_group.errors);
            } else {
              onClose();
              onUnexpectedError();
            }
          });
      }
    }>
    {
      ({
         values,
         handleChange,
         handleSubmit,
         setValues
       }) => <ModalComponent
        className="edit-permission-group-modal"
        title={permissionGroup.id ? 'Edit Group' : 'Add Group'}
        buttons={[
          <Button type="submit" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Saving...' : 'Save'}
          </Button>
        ]}>
        <ValidationErrors errors={errors}/>

        <Row className='mb-3'>
          <label className="form-label col-form-label col-8 text-end">Group Name</label>
          <div className="controls col-16">
            <FormControl type="text" name="name" defaultValue={values.name} onChange={handleChange}/>
          </div>
        </Row>
        <PermissionChecklist
          flags={flags}
          values={values}
          setValues={setValues}
          handleChange={handleChange}
          disabled={false}
        />
      </ModalComponent>
    }
  </Formik>;
};

EditGroupModal.propTypes = {
  permissionGroup: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })
};

const mapDispatchToProps = (dispatch) => ({
  onSave: permissionGroup => dispatch(permissionGroups.actions.save(permissionGroup)).then(() => dispatch(permissionGroups.actions.markDirty())),
  onClose: () => dispatch(modals.actions.hide()),
  onUnexpectedError: () => dispatch(modals.actions.show('UnexpectedError'))
});

export default connect(null, mapDispatchToProps)(EditGroupModal);
